<script>
import MixedGridSortSelect from '@phoenix/mixins/components/mixedGrid/MixedGridSortSelect';
import FormGroup from '@maison/components/form/FormGroup.vue';
import RadioListField from '@maison/components/form/fields/RadioListField.vue';
import { map, pick } from 'lodash-es';

export default {
  components: {
    FormGroup,
    RadioListField,
  },

  mixins: [MixedGridSortSelect],

  props: {
    uniqueId: {
      type: String,
      required: true,
    },
  },

  computed: {
    field() {
      return {
        id: `${this.uniqueId}-sort`,
        name: 'sort',
        type: 'radio',
        value: this.localValue,
        options: map(pick(this.sortOptions, ['priceAsc', 'priceDesc']), (item, value) => ({
          id: value,
          value,
          label: this.$t(item.label),
        })),
      };
    },
  },
};
</script>

<template>
  <form-group :attrs="field" :show-label="false" is-fieldset fieldset-fields-spacing="4" fieldset-horizontal>
    <radio-list-field v-model="localValue" :should-validate="false" />
  </form-group>
</template>
